import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const FormSection = ({ children, sectionText, className, qaId }) => {
  const formSectionClasses = classNames('uni-form__section', {
    [className]: className,
  });

  return (
    <div className={formSectionClasses} data-qa-id={qaId}>
      <fieldset>
        <legend className="uni-form__section-header">{sectionText}</legend>
        {children}
      </fieldset>
    </div>
  );
};

FormSection.propTypes = {
  children: PropTypes.node,
  sectionText: PropTypes.string,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

export default FormSection;



// WEBPACK FOOTER //
// ./src/forms/form-section/index.jsx